module.exports = __webpack_public_path__ + "static/media/p4_s4.0a3be74b.ogg";